<template>
  <div class="common-share">
    <img class="img" src="./imgs/bg.png" />
    <div style="z-index: 1">
      <!-- <div class="title-box">
        <img src="./imgs/title.png" alt="" />
      </div> -->
      <div class="bottom-box">
        <div class="text-img">
          <span class="share_text1"
            >您的好友刚刚领取了红包，你也赶紧去试试吧</span
          >
        </div>
        <div class="text-img">
          <span class="share_text2"
            >完成注册认证后您和好友都可领取4.9元红包</span
          >
        </div>
        <div class="text-img">
          <span class="share_text3"
            >认证成功后邀请1人认证，您可再次领取4.9元红包</span
          >
        </div>
        <notice />
        <div class="button-wrp">
          <img @click="to" class="btn" src="./imgs/btn.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import notice from './notice'
import { POINT_CODE, BURY_POINT_TYPE } from '@/libs/config'
import { buriedChannelPoint } from '@/api/common'
export default {
  name: 'common-share',
  components: {
    notice,
  },
  data() {
    return {
      noticeList: [],
      inviteSysUserId: '',
    }
  },
  mounted() {
    this.inviteSysUserId = this.$route.query.inviteSysUserId
      ? this.$route.query.inviteSysUserId
      : ''
    this.buriedPointPage()
  },
  methods: {
    async buriedPointPage() {
      let params = {
        code: POINT_CODE.SPREAD_PAGE,
        type: BURY_POINT_TYPE.PAGE,
        extra: { inviteUserId: Number(this.inviteSysUserId) },
      }
      console.log(params)
      await buriedChannelPoint(params)
    },
    to() {
      this.$router.push(
        `/activity/act-login?inviteSysUserId=${this.inviteSysUserId}&inviteSource=2`
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.common-share {
  height: 100%;
  overflow: hidden;
  position: relative;
  background: #472bbf;
  ::v-deep .van-icon {
    color: #111111;
  }
  ::v-deep .buyer-show .notice-swipe {
    color: #fff;
  }
  .img {
    width: 100%;
  }
  .title-box {
    width: 100%;
    position: absolute;
    top: 80px;
    text-align: center;
    img {
      width: 280px;
    }
  }
  .bottom-box {
    position: absolute;
    width: 100%;
    bottom: 0px;
    .button-wrp {
      text-align: center;
      .btn {
        width: 315px;
      }
    }
    .text-img {
      text-align: center;
      .share_text1 {
        text-align: center;
        opacity: 0.4;
      }
      .share_text2 {
        margin-top: 3px;
        opacity: 0.6;
      }
      .share_text3 {
        margin-top: 3px;
        opacity: 0.8;
      }
      span {
        display: inline-block;
        font-size: 12px;
        // background: linear-gradient(
        //   90deg,
        //   rgba(43, 68, 198, 0.4) 0%,
        //   #0f26ab 52%,
        //   rgba(18, 43, 171, 0.6) 100%
        // );
        // border-radius: 12px;
        // border: 1px solid rgba(122, 139, 234, 1);
        padding: 2px 0;
        // color: rgba(122, 139, 234, 1);
        color: #fff;
      }
      @media screen and (max-height: 678px) {
        display: none;
      }
    }
    .text {
      text-align: center;
      color: #51b4ff;
      margin-bottom: 10px;
      font-size: 13px;
    }
  }
}
</style>